import Header from './headerSecondary';
import Footer from './footer';

const Layout = ({ children }: any) => {
  
  return (
    <>
      <Header />
        {children}
      <Footer />
    </>
  );
};

export default Layout;
